module.exports = __webpack_public_path__ + "static/media/oberflex-acajout17-1200x2490.875bed4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-acajout17-1200x2490.jpg
// module id = 966
// module chunks = 37